import React from 'react';
import { stats } from '../../data/mock';

export const AboutSection = () => (
  <section className="valuare-sobre-section" id="sobre" data-testid="about-section">
    <div className="valuare-sobre-inner">
      <div className="valuare-sobre-text">
        <div className="valuare-section-label valuare-label-light">Quem somos</div>
        <h2 className="valuare-section-title valuare-title-light">
          Rigor Metodológico<br />& <em>Independência Profissional</em>
        </h2>
        <p className="valuare-sobre-p">
          A Valuare JR® desenvolve avaliações imobiliárias certificadas em estrita conformidade com as European Valuation Standards (EVS), emitidas pela The European Group of Valuers&apos; Associations (TEGoVA), aplicando metodologias reconhecidas internacionalmente.
        </p>
        <p className="valuare-sobre-p">
          Perito Avaliador de Imóveis (PAI) registado na Comissão do Mercado de Valores Mobiliários (CMVM) sob o número PAI/2025/0020 e membro da Associação Nacional de Avaliadores Imobiliários (ANAI) - Carteira Profissional nº 1267, assegurando independência, imparcialidade e rigor técnico.
        </p>
        <p className="valuare-sobre-p">
          A nossa atividade baseia-se em standards de qualidade e deontologia profissional, providenciando relatórios técnicos fundamentados para suporte à decisão em operações imobiliárias, financiamento e processos judiciais.
        </p>
      </div>
      <div className="valuare-sobre-stats">
        {stats.map((stat) => (
          <div key={stat.id} className="valuare-stat">
            <div className="valuare-stat-num">{stat.number}</div>
            <div className="valuare-stat-label">{stat.label}</div>
          </div>
        ))}
      </div>
    </div>
  </section>
);
